var Layout         = require("enyo/Layout"),
    PopupVariables = require("app/theme/styles/MediaDetailPopupVariables"),
    appThemeVars   = require("app/theme/variables.js"),
    dom            = require("enyo/dom"),
    kind           = require("enyo/kind");

module.exports = kind(/** @lends  app.MediaDetailPopup.MediaDetailViewLayout.prototype */ {

    /**
     * @private
     */
    name: "app.MediaDetailPopup.MediaDetailViewLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @private
     */
    metrics: {},

    /**
     * @private
     */
    reflow: function() {
        this.metrics = {};
        this.reflowContainer();
        this.reflowThumbnailArea();
        this.reflowActions();
        this.reflowTabs();
        this.reflowBackground();
    },

    /**
     * @private
     */
    reflowContainer: function() {
        var $container         = this.container,
            $appView           = $container.app.view,
            headerRegionBounds = $appView.get("headerRegionBounds") || {},
            popupLayoutMetrics = $container.get("mediaDetailsPopupLayoutMetrics"),
            paddingTop,
            width,
            minHeight;

        // Page Layout
        if (appThemeVars.windowWidth < PopupVariables.getLayoutBreakpointPx()) {
            // Optionally make space for the app header
            paddingTop = appThemeVars.appHeaderFloat
                ? headerRegionBounds.height || 0
                : 0;

            // Scale to thumbnail the AppLayout's Content Region
            width     = popupLayoutMetrics.popupWidth || 0;
            minHeight = popupLayoutMetrics.popupHeight || 0;
        }

        // Popup Layout
        else {
            paddingTop = 0;
            width      = popupLayoutMetrics.popupWidth || 0;
            minHeight  = 0;
        }

        $container.addStyles({
            paddingTop: paddingTop + "px",
            width:      width + "px",
            minHeight:  minHeight + "px"
        });

        this.metrics.containerPaddingTop = paddingTop;
        this.metrics.containerWidth      = width;
        this.metrics.containerMinHeight  = minHeight;
        this.metrics.popupHeight         = popupLayoutMetrics.popupHeight || 0;
        this.metrics.popupMaxHeight      = popupLayoutMetrics.popupMaxHeight || 0;
    },

    /**
     * @private
     */
    reflowThumbnailArea: function() {
        var $container          = this.container,
            $thumbnailArea      = $container.$.thumbnailArea,
            $thumbnailContainer = $container.$.thumbnailContainer,
            $thumbnail          = $container.$.thumbnail,
            paddingTop,
            paddingBottom,
            maxThumbnailWidth,
            maxThumbnailHeight,
            thumbnailAspectRatio,
            thumbnailSize;

        // Space around the thumbnail, revealing background
        paddingTop    = PopupVariables.getThumbnailAreaPaddingTopPx();
        paddingBottom = PopupVariables.getThumbnailAreaPaddingBottomPx();

        $thumbnailArea.addStyles({
            paddingTop:    paddingTop + "px",
            paddingBottom: paddingBottom + "px"
        });

        this.metrics.thumbnailAreaPaddingTop    = paddingTop;
        this.metrics.thumbnailAreaPaddingBottom = paddingBottom;

        // Calculate the maximum space available to the Thumbnail and derive the
        // maximum Thumbnail size from that given it's aspect ratio
        maxThumbnailWidth    = PopupVariables.getThumbnailMaxWidthPx(this.metrics);
        maxThumbnailHeight   = PopupVariables.getThumbnailMaxHeightPx(this.metrics);
        thumbnailAspectRatio = ($thumbnail.get("rawImageSrc") || {}).ratio || 1;
        thumbnailSize        = this.calcMaxFittingThumbnail(
            maxThumbnailWidth,
            maxThumbnailHeight,
            thumbnailAspectRatio
        );

        $thumbnailContainer.addStyles({
            width:  thumbnailSize.width + "px",
            height: thumbnailSize.height + "px"
        });

        this.metrics.thumbnailWidth  = thumbnailSize.width;
        this.metrics.thumbnailHeight = thumbnailSize.height;
    },

    /**
     * @private
     */
    reflowActions: function() {
        var $container       = this.container,
            $actions         = $container.$.actions,
            $bookmarkButton1 = $container.$.bookmarkButton1,
            $bookmarkButton2 = $container.$.bookmarkButton2,
            $followButton    = $container.$.followButton,
            $shareButton     = $container.$.shareButton,
            actionsNode      = $actions.hasNode(),
            actionsWidth,
            actionsPaddingLeft,
            actionsPaddingRight,
            showBigBookmarkButton;

        actionsWidth        = actionsNode
            ? parseFloat(dom.getComputedStyleValue(actionsNode, "width"), 10)
            : 0;
        actionsPaddingLeft  = actionsNode
            ? parseFloat(dom.getComputedStyleValue(actionsNode, "padding-left"), 10)
            : 0;
        actionsPaddingRight = actionsNode
            ? parseFloat(dom.getComputedStyleValue(actionsNode, "padding-right"), 10)
            : 0;

        showBigBookmarkButton = actionsNode && (
            actionsWidth - actionsPaddingLeft - actionsPaddingRight
            > PopupVariables.getLargeBookmarkButtonMinSpacePx()
        );

        if (showBigBookmarkButton) {
            // Hide small bookmark button
            if ($bookmarkButton2.hasNode()) {
                $bookmarkButton2.removeNodeFromDom();
                $bookmarkButton2.teardownRender();
            }
            $bookmarkButton2.set("canGenerate", false);

            // Show large bookmark button
            $bookmarkButton1.set("canGenerate", true);
            !$bookmarkButton1.hasNode() && $bookmarkButton1.render();
        }
        else {
            // Hide large bookmark button
            if ($bookmarkButton1.hasNode()) {
                $bookmarkButton1.removeNodeFromDom();
                $bookmarkButton1.teardownRender();
            }
            $bookmarkButton1.set("canGenerate", false);

            // Show small bookmark button
            $bookmarkButton2.set("canGenerate", true);
            !$bookmarkButton2.hasNode() && $bookmarkButton2.render();
        }

        if (PopupVariables.showSmallButtonCaptions()) {
            $bookmarkButton2.set("showCaption", true);
            $followButton.set("showCaption", true);
            $shareButton.set("showCaption", true);
        }
        else {
            $bookmarkButton2.set("showCaption", false);
            $followButton.set("showCaption", false);
            $shareButton.set("showCaption", false);
        }
    },

    /**
     * @private
     */
    reflowTabs: function() {
        var $container = this.container,
            $info      = $container.$.info,
            $credits   = $container.$.credits,
            activeTab  = $container.get("activeTab");

        if (appThemeVars.windowWidth < PopupVariables.getLayoutBreakpointPx()) {
            $info.set("showing", $info.get("tab") === activeTab);
            $credits.set("showing", $credits.get("tab") === activeTab);
        }
        else {
            $info.show();
            $credits.show();
        }
    },

    /**
     * @private
     */
    reflowBackground: function() {
        var $container         = this.container,
            $appView           = $container.app.view,
            $background        = $container.$.background,
            headerRegionBounds = $appView.get("headerRegionBounds") || {},
            containerBounds,
            width,
            height;

        width  = this.metrics.containerWidth || 0;
        height = PopupVariables.getBackgroundHeightPx(this.metrics);

        height += appThemeVars.appHeaderFloat
            ? headerRegionBounds.height || 0
            : 0;

        containerBounds = $container.getBounds();
        height          = Math.min(height, containerBounds.height);

        $background.addStyles({
            width:  width + "px",
            height: height + "px"
        });

        this.metrics.backgroundWidth  = width;
        this.metrics.backgroundHeight = height;
    },

    /**
     * @param   {number}  maxWidth     The maximum width of the thumbnail
     * @param   {number}  maxHeight    The maximum height of the thumbnail
     * @param   {number}  aspectRatio  The aspect ratio of the thumbnail
     * @return  {Object}  The largest width and height that fit within the
     *                    bounds given the provided aspect ratio.
     * @private
     */
    calcMaxFittingThumbnail: function(maxWidth, maxHeight, aspectRatio) {
        var width,
            height;

        width  = maxWidth;
        height = width / aspectRatio;

        if (height > maxHeight) {
            height = maxHeight;
            width  = height * aspectRatio;
        }

        return {
            width:  width,
            height: height
        };
    }

});
